import React from 'react';
import Scroll from 'react-scroll';
import TermsAndConditions from '../screens/static/TermsAndConditions';
import ContactTypes from '../screens/static/ContactTypes';
import { isEveryValid, isEmailValid, isLengthValid, isWWWValid, scrollToError, firstError } from '../services/utils';
import { getCompanyRequest, isEmailAvaible, isCompanyEmailAvailable } from '../services/api';

import Textinput from './textinput';
import UserForm from './userForm';

class UserPopup extends React.Component {

    constructor(props) {
        super(props);

        this.initialStateUser = {
            contact_type: '1',
            salutation: '',
            name: '',
            title: '',
            function: '6',
            email: '',
            emailAvailability: '',
            skype: '',
            whatsapp: '',
            deleted: false,
            validation: {
                contact_type: true,
                salutation: false,
                name: false,
                title: false,
                function: true,
                email: false
            }
        }

        this.initialState = {
            market_id: '',
            company_name: '',
            cme_cleared: '',
            address: '',
            post_code: '',
            city: '',
            state: '',
            country: '27',
            email: '',
            companyEmailAvailability: '',
            direct_phone: '',
            web: '',
            terms: false,
            users: [this.initialStateUser],
            validation: {
                market_id: false,
                company_name: false,
                address: false,
                post_code: false,
                direct_phone: false,
                terms: false,
                web: true,
                email: true,                
            },
            submitCliked: false,
            deletedUsers: []
        }

        this.state = this.initialState;

        this.isFetched = false;
        this.prevCompanyId = '';

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeUser = this.handleChangeUser.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.showTerms = this.showTerms.bind(this);
        this.addUser = this.addUser.bind(this);
        this.removeUser = this.removeUser.bind(this);
        this.viewAsUser = this.viewAsUser.bind(this);
        this.clearForm = this.clearForm.bind(this);
        this.setEmailAvailability = this.setEmailAvailability.bind(this);
        this.setCompanyEmailAvailability = this.setCompanyEmailAvailability.bind(this);
        this.openContactTypeHelper = this.openContactTypeHelper.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        let { userPopupCompanyId } = nextProps.state.app;
        this.fillForm(userPopupCompanyId);
    }

    closePopup(e) {
        if (e.target.getAttribute('name') == 'userPopup') {
            this.props.actions.hideUserPopup();
        }
    }

    handleChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        let stateProps = {},
        newValue = value;

        if (name=='terms') newValue = !this.state.terms;
        if (name=='cme_cleared') {
            newValue = !this.state.cme_cleared;
        }
        // market id should be integer only
        if (name=='market_id') {
            newValue = parseInt(newValue);
        }

        stateProps = {
            [name]: newValue
        };

        this.setState(stateProps, () => { this.validateField(name, newValue) });
    }

    handleChangeUser(e, index) {
        const name = e.target.name;
        const value = e.target.value;
        let usersTemp = this.state.users;

        usersTemp[index] = {
            ...this.state.users[index],
            [name]: value
        }

        this.setState({
            users: usersTemp
        }, () => { this.validateFieldUser(name, value, index) });

    }

    validateField(fieldName, value) {
        if (fieldName in this.state.validation) {
            if (fieldName === 'address' ||
                fieldName === 'post_code' ||
                fieldName === 'company_name') {
                value = isLengthValid(value, fieldName, 'company');
            }
            if (fieldName === 'web') {
                value = isWWWValid(value);
            }

            if (fieldName === 'email') {                
                let emailValue = value;
                value = (value === '' || isEmailValid(value));

                if (value) {
                    isCompanyEmailAvailable(emailValue).then( () => {
                        this.setCompanyEmailAvailability(true);
                    }).catch( () => {
                        this.setCompanyEmailAvailability(false);
                    });
                }
            }

            this.setState({
                validation: {
                    ...this.state.validation,
                    [fieldName]: value ? true : false
                }
            });
        }
    }

    validateFieldUser(fieldName, value, userIndex) {
        let usersTemp = this.state.users,
        { user } = this.props.state;

        if (fieldName in this.state.users[userIndex].validation) {
            const stringInputs = ['title', 'email', 'skype', 'whatsapp', 'name'];

            if (fieldName=='email') {
                let emailValue = value,
                userId = user.isLoggedIn ? this.state.users[userIndex].id : false;
                value = isEmailValid(value);

                if (value) {
                    isEmailAvaible(emailValue, userId).then( () => {
                        this.setEmailAvailability(userIndex, true);
                    }).catch( () => {
                        this.setEmailAvailability(userIndex, false);
                    });
                }
            }

            if (stringInputs.indexOf(fieldName) !== -1) {
                value = isLengthValid(value, fieldName);
            }

            usersTemp[userIndex].validation = {
                ...usersTemp[userIndex].validation,
                [fieldName]: value ? true : false
            }
            this.setState({
                users: usersTemp
            });
        }
    }

    setEmailAvailability(index, isAvaible) {
        let usersTemp = this.state.users,
        message = 'This email address has been already used. Please enter another one.',
        emailAvailability = isAvaible ? '' : message;

        usersTemp[index] = {
            ...usersTemp[index],
            emailAvailability,
            validation: {
                ...usersTemp[index].validation,
                email: isAvaible,
            }
        }
        this.setState({
            users: usersTemp
        });
    }

    setCompanyEmailAvailability(isAvailable) {
        let companyTemp = Object.assign({}, this.state),
        message = 'This email address has been already used. Please enter another one.',
        companyEmailAvailability = isAvailable ? '' : message;

        companyTemp = {
            ...companyTemp,
            companyEmailAvailability,
            validation: {
                ...companyTemp.validation,
                email: isAvailable,
            }
        }
        this.setState(companyTemp);
    }

    openContactTypeHelper() {
        this.props.actions.showPopup({
            title: 'Contact types',
            content: ContactTypes(),
            buttonText: 'Ok'
        });
    }

    fillForm(companyId) {
        let { user, app } = this.props.state;
        let validation = {},
        usersValidation = [];

        if (this.prevCompanyId != companyId) this.isFetched = false;

        if (!user.isLoggedIn && this.isFetched) this.clearForm();

        if (companyId == -1) {
            companyId = '';
        }
        if (user.isLoggedIn && !this.isFetched) {
            getCompanyRequest(companyId).then( response => {
                this.isFetched = true;
                this.prevCompanyId = companyId;
                //Fill company data
                let mainData = response.data;
                mainData.company_name = mainData.name;
                //Check company validation
                for (let key in this.state.validation) {
                    validation[key] = !!(key in mainData && mainData[key]);
                }
                validation.terms = true;
                mainData.validation = validation;

                // Fill users data
                let users = response.data.users;

                //Check users validation
                users.map( (user, i) => {
                    usersValidation.push({});
                    user.validation = this.initialStateUser.validation;
                    for (let key in user.validation) {
                        usersValidation[i][key] = !!(key in user && user[key]);
                    }
                    user.validation = usersValidation[i];
                });

                //Setting data
                this.setState({
                    ...this.state,
                    ...mainData,
                    company_name: mainData.name,
                    users: users
                });

            }).catch( err => console.log(err) );

        }

    }

    handleSubmit() {
        let isValid = isEveryValid(this.state.validation);
        let errorField = firstError(this.state.validation);
        let isUsersValid = [];
        let { address, city, company_name, country, direct_phone, email, market_id,
            post_code, state, terms, users, web } = this.state;
        let { isLoggedIn, isAdmin, isSuperUser } = this.props.state.user,
        companyId = this.props.state.app.userPopupCompanyId;

        const updateCallback = () => {
            if (companyId) this.props.actions.getCompanies();
            this.clearForm();
        }

        const nonDeletedUsers = this.state.users.filter(user => !user.deleted);
        let hasMasterUser = false;
        nonDeletedUsers.map((item,i) => {
            let isUserValid = isEveryValid(nonDeletedUsers[i].validation);
            isUsersValid.push(isUserValid)
            errorField = errorField || (!isUserValid && i + firstError(nonDeletedUsers[i].validation));
            hasMasterUser = hasMasterUser || item.contact_type === '1';
        });

        this.setState({
            ...this.state,
            submitCliked: true,
        });

        if (isValid && isUsersValid.every( item => item ) && hasMasterUser) {
            const isRegularUser = !isAdmin && !isSuperUser;

            if (isLoggedIn) {
                //Updating
                this.props.actions.updateCompanyDetails({
                    ...this.state,
                    users: nonDeletedUsers,
                    name: this.state.company_name,
                }, isRegularUser, updateCallback);
            } else {
                //Creating
                this.props.actions.signup({
                    address,
                    city,
                    company_name,
                    country,
                    direct_phone,
                    email,
                    market_id,
                    name: company_name,
                    post_code,
                    state,
                    terms,
                    users: nonDeletedUsers,
                    web,
                }, this.clearForm);
            }
        } else {
            let errorMessage = 'Please make sure all the information is correct and try again.';
            if (!hasMasterUser && !errorField) {
                errorMessage = 'Any company needs to have at least one master user. Please assign another master user, before removing this one.';
                errorField = '0contact_type';
            }
            this.props.actions.showPopup({
                title: 'Error',
                content: errorMessage,
                buttonText: 'Dismiss'
            });
            console.log(this.state);
            scrollToError(errorField, 'user-popup-scroll-container');           
        }
    }

    clearForm() {
        this.isFetched = false;
        this.setState({
            ...this.initialState,
            users: [this.initialStateUser]
        });
    }

    showTerms() {
        this.props.actions.showPopup({
            title: 'DIRECT HEDGE SA TERMS AND CONDITIONS OF USE',
            content: TermsAndConditions(),
            large: true,
            buttonText: 'Ok'
        });
    }

    addUser() {
        let usersTemp = this.state.users;

        usersTemp.push({
            ...this.initialStateUser,
            contact_type: '',
            validation: {
                ...this.initialStateUser.validation,
                contact_type: false
            }
        });

        this.setState({
            users: usersTemp
        })
    }

    removeUser(index) {
        const usersTemp = this.state.users;
        const deletedUsers = this.state.deletedUsers;
        const deletedId = usersTemp[index].id;
        
        usersTemp[index].deleted = true;

        if (deletedId) deletedUsers.push(deletedId);

        this.setState({
            users: usersTemp,
            deletedUsers
        })
    }

    viewAsUser(index) {        
        const userId = this.state.users[index].id;
        this.props.actions.impersonateUser(userId);
    }   

	render() {
        let { app, user, markets } = this.props.state;
        let { submitCliked, validation } = this.state,
        countries = app.countries,
        companyId = app.userPopupCompanyId,
        popupTitle = user.isLoggedIn ? ((companyId ? 'Edit' : 'Your') + ' company details') : 'Sign Up';

        return (
            <div
                onClick={this.closePopup.bind(this)}
                name='userPopup'
                style={{display: app.isUserPopupVisible ? 'block' : 'none'}}
                className='signup-container generic-popup-container'
                id='user-popup-scroll-container'>
                <div className='form'>
                    <div id='signup'>
                        <h1>{ popupTitle }</h1>
                        <h3>Choose market</h3>
                        <div className={`field-wrap ${!validation.market_id && submitCliked ? 'error' : ''}`}>
                            <Scroll.Element name='market_id' />
                            <label
                                htmlFor='market_id'
                                className='labelactive'>
                                Select market<span className='req'>*</span>
                            </label>

                            <select name='market_id' onChange={this.handleChange} value={this.state.market_id}>
                                <option disabled='' value=''> -- select a market -- </option>
                                { markets ? markets.data.map( (item, i) =>
                                    <option key={'market_opt'+item.id} value={item.id}>{item.name}</option>
                                ) : null }
                            </select>
                        </div>
                        <h3>Company Name</h3>
                        <Textinput
                            label='Full company name'
                            name='company_name'
                            model='company'
                            value={ this.state.company_name }
                            onChange={ this.handleChange }
                            required={true}
                            invalid={!validation.company_name && submitCliked}
                            type='text' />

                        { ((user.isAdmin || user.isSuperUser) && companyId) ?
                        <div className='field-wrap'>
                            <input
                                type='checkbox'
                                name='cme_cleared'
                                id='cme_cleared'
                                checked={this.state.cme_cleared ? 'checked' : ''}
                                onChange={this.handleChange} />
                            <label htmlFor='cme_cleared' className='checkbox-label'>is CME</label>
                        </div>
                        : null }

                        <h3>Company Address</h3>
                        <Textinput
                            label='Address'
                            name='address'
                            value={ this.state.address }
                            onChange={ this.handleChange }
                            required={true}
                            invalid={!validation.address && submitCliked}
                            type='text' />

                        <Textinput
                            label='Post/Zip code'
                            name='post_code'
                            value={ this.state.post_code }
                            onChange={ this.handleChange }
                            required={true}
                            invalid={!validation.post_code && submitCliked}
                            type='number' />

                        <Textinput
                            label='City'
                            name='city'
                            value={ this.state.city }
                            onChange={ this.handleChange }
                            type='text' />

                        <Textinput
                            label='State (US entities only)'
                            name='state'
                            value={ this.state.state }
                            onChange={ this.handleChange }
                            type='text' />
                        <div className='field-wrap'>
                            <label htmlFor='country' className='labelactive'>
                            Country<span className='req'>*</span>
                            </label>
                            <select name='country' onChange={ this.handleChange } value={ this.state.country || '' }>
                                { countries && countries.length ? countries.map( item =>
                                    <option key={'country'+item.id} value={item.id}>{item.name}</option>
                                ) : null }
                            </select>
                        </div>

                        <h3>Company Contact</h3>
                        <Textinput
                            label='Main Telephone Number'
                            name='direct_phone'
                            value={ this.state.direct_phone }
                            onChange={ this.handleChange }
                            required={true}
                            invalid={!validation.direct_phone && submitCliked}
                            type='number' />

                        <Textinput
                            label='Website'
                            name='web'
                            value={ this.state.web }
                            onChange={ this.handleChange }
                            type='text'
                            invalid={!validation.web && submitCliked} />

                        <Textinput
                            label='Email'
                            name='email'
                            value={ this.state.email }
                            onChange={ this.handleChange }
                            type='email'
                            invalid={(!validation.email && submitCliked) || this.state.companyEmailAvailability} />

                        { this.state.companyEmailAvailability ?
                            <div className='field-note'>{ this.state.companyEmailAvailability }</div>
                        : null }

                        { !user.isLoggedIn ?
                        <div className='field-wrap'>
                            <input type='checkbox' name='terms' value={this.state.terms} onChange={this.handleChange} />
                            <div className={'terms-label '+(!validation.terms && submitCliked ? 'error' : '')}>
                                I accept the <span className='terms-link' onClick={this.showTerms}>Terms and Conditions</span><span className='req'>*</span>
                            </div>
                        </div>
                        : null }

                        { this.state.users.map( (index, i) =>
                            <UserForm
                                index={i}
                                key={'user'+i}
                                handleChange={this.handleChangeUser}
                                removeUser={this.removeUser}
                                openContactTypeHelper={this.openContactTypeHelper}
                                submitCliked={submitCliked}
                                state={this.state.users[i]}
                                isSuperUser={user.isSuperUser || user.isAdmin}
                                viewAsUser={this.viewAsUser}
                                isCompanyApproved={this.state.approved}
                                isSignup={!user.isLoggedIn} />
                        ) }                        

                        <div className='field-wrap'>
                            <div className='multi-column-row'>
                                <div className='column'>
                                    <button
                                        onClick={this.addUser}
                                        className='button button-block'>Add user</button>
                                </div>
                                <div className='column'>
                                    <button
                                        onClick={this.handleSubmit}
                                        className='button button-block'>{ user.isLoggedIn ? 'Update' : 'Sign up'}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default UserPopup;



// WEBPACK FOOTER //
// ./source/components/userPopup.js